import React, {Component} from 'react'
import {Link} from 'react-router'
import {Grid, Menu, Icon} from 'semantic-ui-react'
import {connect} from 'react-redux'
import featureConfig from '../../services/features/config'
import isFeatureAllowed from '../../services/features/feature-check'

const featureIds = featureConfig.featureIds

class SettingsLayout extends Component {
  render () {
    const isTemplateAllowed = isFeatureAllowed(featureIds.createTemplate, this.props.location)
    const isTeamAllowed = isFeatureAllowed(featureIds.createTeam, this.props.location)
    const {children} = this.props
    const templates = (
      <Menu.Item as={Link} className='item' activeClassName='active' to={'/settings/templates'}>Forms
        {this.props.templates.map(template => {
          const url = '/settings/templates/' + template.id
          var isTemplateEditable = template.is_active
          return (
            <Menu.Item as={Link} disabled={!isTemplateEditable} style={{fontSize: '12px'}} key={template.id} className='item' activeClassName='active' to={isTemplateEditable ? url : null}>{template.name} {!isTemplateEditable ? <Icon name='lock' />:undefined}</Menu.Item>
          )
        })}
        <Menu.Item as={Link} disabled={!isTemplateAllowed} style={{fontSize: '12px'}} className='item' activeClassName='active' to={isTemplateAllowed ? '/settings/templates' : null}>+ Add new {!isTemplateAllowed ? <Icon name='lock' />:undefined}</Menu.Item>
      </Menu.Item>
    )
    const settingsNav = (
      <Menu secondary vertical>
        <Menu.Item as={Link} className='item' activeClassName='active' to='/settings/profile'>Profile</Menu.Item>
        <Menu.Item as={Link} className='item' activeClassName='active' to='/settings/billing'>Billing</Menu.Item>
        {/* <Link className='item' activeClassName='active' to='/settings/company'>Company</Link> */}
        <Menu.Item as={Link} className='item' activeClassName='active' to='/settings/devices'>Devices</Menu.Item>
        <Menu.Item as={Link} className='item' disabled={!isTeamAllowed} activeClassName='active' to={isTeamAllowed ? '/settings/team' : null}>Team {!isTeamAllowed ? <Icon name='lock' /> : undefined}</Menu.Item>
        {templates}
      </Menu>
    )

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column mobile={16} width={4} computer={4}>
            {settingsNav}
          </Grid.Column>
          <Grid.Column mobile={16} width={12} computer={12}>
            {children}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

function mapStateToProps (state) {
  return {templates: state.templates.templates, location: state.account.user.locations_data[0]}
}

export default connect(mapStateToProps, {})(SettingsLayout)



// WEBPACK FOOTER //
// ./src/pages/settings/layout.js